import React from "react";
import "./ToggleSwitch.css";

interface ToggleProps {
    active: boolean;
    onToggle: (state: boolean) => void;
    label?: string;
    buttonLabel?: string;
    onChange?: () => void;
}

function ToggleSwitch({active, onToggle, label, buttonLabel, onChange}: ToggleProps) {
    return (
        <div className={`country-filter ${active ? "country-filter--active" : ""}`}>
            <span className="country-filter__label">{label}</span>

            {/* Added standard aria attributes for screen reader accessibility */}
            <button
                type="button"
                onClick={() => onToggle(!active)}
                className={`toggle ${active ? "toggle--active" : ""}`}
                aria-pressed={active}
                data-text={active ? "ON" : "OFF"}
            >
                <span className="toggle__thumb"/>
            </button>

            <button
                type="button"
                onClick={onChange}
                className="country-filter__change-btn"
            >
                {buttonLabel}
            </button>
        </div>
    );
}

export default ToggleSwitch;
